export default __webpack_public_path__ + "static/media/hamburger.df1e503b.svg";